import { DSImageProps, DSNCBestProductGallery } from 'shared-definitions/types'
import { ApiComponentBestProductGallery } from 'data-source/types.wp'
import { bestProductPropsMapper } from 'data-source/mappers/bestProductPropsMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncBestProductGallery(
  input: ApiComponentBestProductGallery,
  opts: PLinkMapperOpts
): DSNCBestProductGallery {
  return {
    resource: 'nc-best-product-gallery',
    images: input.gallery.map(i => imageMapper(i, opts)).filter(i => i !== null) as DSImageProps[],
    headLabel:
      input.icon && input.icon_title
        ? {
            icon: input.icon,
            title: input.title,
          }
        : null,
    ...bestProductPropsMapper(input, opts),
  }
}
